import { OpenGraph } from 'next/dist/lib/metadata/types/opengraph-types'
import { Twitter } from 'next/dist/lib/metadata/types/twitter-types'

import { TWITTER_CREATOR, TWITTER_SITE } from '@/app/_constants/twitter-detail'

export const FIRST_LOAD_PAGE_SIZE = 72
export const PAGE_SIZE = 24
export const ONLY_IN_STOCK_PRODUCTS_TITLE = 'فقط کالاهای موجود'
export const SHOW_MORE_BUTTON_CHARACTER_LIMIT = 400

export const PLP_VIRTUAL_GRID_COLUMNS_COUNT = {
    mobile: 2,
    desktop: 4,
}
export const FIRST_LAZY_PRODUCT_INDEX = {
    mobile: 6,
    desktop: 8,
}

export const OPEN_GRAPH_METADATA: OpenGraph = {
    type: 'website',
    siteName: 'خانومی',
}

export const TWITTER_CART_METADATA: Twitter = {
    card: 'summary',
    site: `@${TWITTER_SITE}`,
    creator: `@${TWITTER_CREATOR}`,
}
